import styled from 'styled-components';

export const Remove = styled.span`
  cursor: pointer;
  font-size: 0.625rem;
  color: red;
  text-decoration: underline;
  margin-right: 4px;
`;
